import { Translate } from 'next-translate'

import { OrderListItem } from '../utils/types/buyerCatalogs'
import { getIsImportedProduct } from './product'
import { normalizeString } from '../utils/util'

export const getPickedSuppliers = (catalogItems: OrderListItem[], t: Translate) => {
  if (catalogItems.length === 0 || !catalogItems) {
    return ''
  }

  const suppliersList = [
    ...new Set(
      catalogItems
        .filter((item) => !!item.product)
        .map((item) => {
          const supplierLabel = item.product?.supplier?.[0]?.['supplier.label']
          return !getIsImportedProduct(item.product) ? supplierLabel : `${supplierLabel} (${t('products:imported')})`
        }),
    ),
  ]

  if (suppliersList.length < 3) {
    return suppliersList.join(', ')
  }

  return t('{{firstSupplier}}, {{secondSupplier}} and {{count}} more', {
    count: suppliersList.slice(2).length,
    firstSupplier: suppliersList.at(0),
    secondSupplier: suppliersList.at(1),
  })
}

export const getCatalogLink = (id: string, name: string) => (`/my-catalogs/${id}+${normalizeString(name.toLowerCase())}`)
